window.constraints_nonconformities = {
    RFC_F: {
        format: {
            pattern: /^[A-Za-z]{4,4}[\d]{6,6}[A-Za-z0-9]{3,3}$/,
            flags: "i",
            message: "^Ingrese un RFC valido."
        }
    },
    RFC_M: {
        format: {
            pattern: /^[A-Za-z]{3,3}[\d]{6,6}[A-Za-z0-9]{3,3}$/,
            flags: "i",
            message: "^Ingrese un RFC valido."
        }
    },
    phone: {
        format: {
            pattern: /^[\d]{10,10}$/,
            flags: "i",
            message: "^Ingrese un número de teléfono a 10 dígitos."
        }
    }
};
